import React, { useRef } from "react";
import { useAuthContext } from "../../context/AuthContext";
import { Button, Form, Input, message, Spin, Select } from "antd";
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useState, useEffect } from "react";
import { makeRequest } from "../../makeRequest";
import { getToken } from "../../helpers";

const UserAddresses = () => {
  const navigate = useNavigate();
  const id = useParams().id;
  const [searchParams] = useSearchParams();
  const refURL = searchParams.get('ref');
  const API = process.env.REACT_APP_API_URL;

  const { user } = useAuthContext();
  const [cityState, setCityState] = useState([]);
  const [addData, setAddData] = useState({});

  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [sCity, setSCity] = useState("");
  const [sCities, setSCities] = useState([]);

  const formRef = useRef(null);

  const handleStateChange = (value) => {
    setSCities(cityState?.states?.filter(state => state.name === value)[0].cities);
    setSCity(cityState?.states?.filter(state => state.name === value)[0].cities[0].name);
  };

  const handleCityChange = (value) => {
    setSCity(value);
  };
  
  const getData = (uID) => {
    setLoadingUpdate(true);
    if (uID !== "create") {
      makeRequest.get(`/user-addresses/${uID}`)
      .then(res => {
        setAddData(res.data.data);
        fetch(`/data/cityState.json`, {
          method: "GET",
        }).then(response => response.json())
        .then(data => {
          setCityState(data[0]);
          setSCities(cityState?.states?.filter(state => state.name === addData?.state)[0].cities);
          setSCity(addData?.city);
          setLoadingUpdate(false);
        });
      });
    } else {
      fetch(`/data/cityState.json`, {
        method: "GET",
      }).then(response => response.json())
      .then(data => {
        setAddData({
          address_type: "Home",
          state: "Delhi",
          city: "New Delhi"
        });
        setCityState(data[0]);
        setSCities(cityState?.states?.filter(state => state.name === "Delhi")[0].cities);
        setLoadingUpdate(false);
      });
    }
  }
  useEffect(() => {
    //console.log(sCity);
    //console.log(sCities);
    //console.log(addData);
    if (sCity) {
      formRef.current?.setFieldsValue({
        city: sCity,
      });
    }
  }, [sCity, sCities, addData]);

  useEffect(() => {
    if(id) {
      getData(id);
    }
  }, [id]);

  const handleAddressUpdate = async (value) => {
    //console.log(data);
    setLoadingUpdate(true);
    let fmethod = "PUT";
    let fURL = `${API}/user-addresses/${id}`;
    if (id === "create") {
      fmethod = "POST";
      fURL = `${API}/user-addresses`;
      value.users_permissions_user = user.id;
    }
    try {
      const response = await fetch(fURL, {
        method: fmethod,
        headers: {
          "Content-Type": "application/json",
          // set the auth token to the user's jwt
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({data: value}),
      });
      const responseData = await response.json();
      //console.log(responseData);
      if(responseData.error) {
        message.error("Error While Updating/Creating the Address!");
      } else {
        message.success("Data saved successfully!");
        refURL ? navigate("/" + refURL, { replace: true }) : navigate("/profile", { replace: true });
      }
    } catch (error) {
      console.error(Error);
      message.error("Error While Updating/Creating the Address!");
    } finally {
      setLoadingUpdate(false);
    }
  };

  return (
    loadingUpdate ? ( "loading" ) : 
    <>
      <div className="container py-5">
        <div className="row py-5">
          <Form
            className="col-md-9 m-auto"
            ref={formRef}
            layout="vertical"
            initialValues={{
              address_type: addData?.address_type,
              address1: addData?.address1,
              address2: addData?.address2,
              state: addData?.state,
              city: sCity ? sCity : addData?.city,
              pincode: addData?.pincode
            }}
            onFinish={handleAddressUpdate}
          >
            <div className="row">
              <div className="form-group col-md-6 mb-3">
                <Form.Item
                  label="Address Type"
                  name="address_type"
                >
                  <Select
                    style={{ width: '100%' }}
                    options={[
                      { value: 'Home', label: 'Home' },
                      { value: 'Office', label: 'Office' },
                      { value: 'Relative', label: 'Relative' }
                    ]}
                  />
                </Form.Item>
              </div>
              <div className="form-group col-md-6 mb-3">
                <Form.Item
                  label="Pincode"
                  name="pincode"
                  rules={[
                    {
                      required: true,
                      message: "Pincode is required!",
                      type: "string",
                    },
                  ]}
                >
                  <Input placeholder="Pincode" />
                </Form.Item>
              </div>
            </div>
            <div className="row">
              <div className="form-group col-md-6 mb-3">
                <Form.Item
                  label="Address 1"
                  name="address1"
                  rules={[
                    {
                      required: true,
                      message: "Address1 is required!",
                      type: "string",
                    },
                  ]}
                >
                  <Input placeholder="Address1" />
                </Form.Item>
              </div>
              <div className="form-group col-md-6 mb-3">
                <Form.Item
                  label="Address 2"
                  name="address2"
                  rules={[
                    {
                      required: true,
                      message: "Address2 is required!",
                      type: "string",
                    },
                  ]}
                >
                  <Input placeholder="Address2" />
                </Form.Item>
              </div>
            </div>
            <div className="row">
              <div className="form-group col-md-6 mb-3">
                <Form.Item
                  label="State"
                  name="state"
                  rules={[
                    {
                      required: true,
                      message: "State is required!",
                      type: "string",
                    },
                  ]}
                >
                  <Select
                    style={{ width: '100%' }}
                    onChange={handleStateChange}
                    options={cityState?.states?.map((province) => ({
                      label: province.name,
                      value: province.name,
                    }))}
                  />
                </Form.Item>
              </div>
              <div className="form-group col-md-6 mb-3">
                <Form.Item
                  label="City"
                  name="city"
                  rules={[
                    {
                      required: true,
                      message: "City is required!",
                      type: "string",
                    },
                  ]}
                >
                  <Select
                    style={{ width: '100%' }}
                    onChange={handleCityChange}
                    options={sCities ? sCities.map((city) => ({ label: city.name, value:city.name })) : 
                      cityState?.states?.filter(state => state.name === addData?.state)[0].cities?.map((city) => ({
                      label: city.name,
                      value: city.name,
                    }))}
                  />
                </Form.Item>
              </div>
            </div>
            <div className="row">
              <div className="col text-end mt-2">
                <Button
                  className="address_save_btn"
                  htmlType="submit"
                  type="primary"
                  size="large"
                >
                  {loadingUpdate ? (
                    <>
                      <Spin size="small" /> Saving
                    </>
                  ) : (
                    "Save"
                  )}
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default UserAddresses;